import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {DefaultService} from './abstract/default.service';
// @ts-ignore
import {BehaviorSubject, Observable} from "rxjs";

@Injectable()
export class SharedUserService extends DefaultService {

    avatar: any;
    onUserUpdate: BehaviorSubject<any>;
    constructor(
        // @ts-ignore
        public override http: HttpClient) {
        super(http);
        this.setResourceLink('users');
        this.onUserUpdate = new BehaviorSubject([]);

    }



    setAvatar(queryParams: any) {
        const formData: FormData = new FormData();
        formData.append('avatar', queryParams.new_avatar, queryParams.new_avatar.name);

        return this.http.post(this.endpoint + this.resourceLink + '/' + queryParams.id + '/post_avatar', formData)
            .pipe(
                tap(
                () => {
                    console.log('setAvatar');
                }
            ));
    }


    getMe() {
        return this.http.get(this.endpoint + this.resourceLink + '/me');
    }


    getAvatar(): Observable<Blob> {
        return this.http.get(this.endpoint + 'user/get_avatar', { responseType: 'blob' });
    }


    getRights(queryParams: any) {
        return this.http.get(this.endpoint + 'users/' + queryParams.id + '/rights');
    }







}
